module.exports = __webpack_public_path__ + "static/media/logo-nare-cup.174abd67.jpg";